module.exports = __webpack_public_path__ + "img/组 1580@2x.25ed19db.png";